import React from "react";
import { Box, Typography } from "@mui/material";
// import herobackgroundvideo from "../assets/videos/hero-bg-h264-video.mp4";
import DownloadApp from "../components/DownloadApp";
import Waitlist from "../components/Waitlist";

import herobackgroundvideoFallbackImage from "../assets/videos/hero-bg-video-fallback-img.png";
const herobackgroundvideo = "https://res.cloudinary.com/dbdvbjtex/video/upload/f_auto:video,q_auto/dvq8caubgclq3fx2onxk.mp4";

const Hero = () => {

  return (
    <Box
      component='section'
      sx={{
        position: 'relative',
        height: 'calc(100vh - 12rem)',
        maxHeight: '120rem',
      }}
    >
      <video
        component='video'
        muted
        playsInline
        autoPlay
        style={{
          position: 'absolute',
          top: '0',
          left: '0',
          width: '100%',
          height: '100%',
          objectFit: 'cover',
          zIndex: '-1',
          background: 'linear-gradient(135deg, rgba(137,88,68,1) 0%, rgba(31,56,23,1) 35%, rgba(200,206,203,1) 100%)',
        }}
        loop
        preLoad="auto"
        id="bg-video"
        poster={herobackgroundvideoFallbackImage}
      >
        <source src={herobackgroundvideo} type="video/mp4" />
        <img src={herobackgroundvideoFallbackImage} alt="SplitEV background"></img>
        Your browser does not support the video tag.
      </video>


      <Box
        sx={{
          display: "flex",
          flexDirection: 'column',
          justifyContent: 'center',
          py: { xs: '8rem', md: '14rem' },
          position: 'relative',
          top: '0',
          left: '0',
          width: '100%',
          height: '100%',
          // maxWidth: '120rem',
          background: "transparent",
          backgroundImage: "radial-gradient(transparent 1px, black 1px)",
          backgroundSize: "2px 2px",
          backdropFilter: 'blur(6px)',
          mask: "linear-gradient(#000 100%, #0000)",
          px: { xs: '2rem', sm: '2rem', md: '6.4rem' },
        }}>

        <Box
          sx={{
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            width: 'fit-content',
            alignItems: 'center',
            justifyContent: 'center',
            textAlign: { xs: 'center', sm: 'left' },
          }}
        >

          <Typography
            sx={{
              color: "#fff",
              fontSize: { xs: '4rem', sm: '8rem', md: '8rem' },
              fontWeight: 700,
              lineHeight: { xs: '4rem', sm: '6rem', md: '7rem' },
              mb: '1.5rem',
              maxWidth: '22ch',
            }}
          >
            The future of EV charging, built for everyone.
          </Typography >

          <Typography
            sx={{
              color: "#fff",
              fontSize: '1.8rem',
              fontWeight: 400,
              my: '2rem',
              maxWidth: '60ch',
            }}
          >
            Charging shouldn’t feel like a hassle. SplitEV connects EV drivers to private chargers for a faster,
            simpler, and more predictable experience. Whether you drive or host, we’ve got you covered.
          </Typography>
        </Box >

        <Box sx={{ width: 'fit-content', margin: { xs: '0 auto', sm: '0' } }}>
          {/* <DownloadApp isHeroSection></DownloadApp> */}
          {<Waitlist></Waitlist>}
        </Box>

      </Box >
    </Box >
  );
};

export default Hero;